import { store } from '..';

import dayjs, { Dayjs } from '@/dayjs';

export interface DateRange {
  from: Dayjs;
  to: Dayjs;
}

export enum RelativeDateRange {
  LAST_MONTH = 'last month',
  LAST_3_MONTHS = 'last 3 months',
  LAST_6_MONTHS = 'last 6 months',
  LAST_YEAR = 'last year',
  LAST_2_YEARS = 'last 2 years',
  LAST_3_YEARS = 'last 3 years',
}

const setDateRangeFrom = (value: Dayjs) => {
  store.daterange.from = value.startOf('month');
};

const setDateRangeTo = (value: Dayjs) => {
  if (value.isSame(dayjs(), 'month')) {
    // never go further than today
    store.daterange.to = value;
  } else {
    // otherwise always select the whole month
    store.daterange.to = value.endOf('month');
  }
};

const setDateRange = (from: Dayjs, to: Dayjs) => {
  setDateRangeFrom(from);
  setDateRangeTo(to);
};

const setRelativeDateRange = (value: RelativeDateRange) => {
  setDateRangeTo(dayjs());
  switch (value) {
    case RelativeDateRange.LAST_MONTH:
      setDateRangeFrom(dayjs().subtract(1, 'month'));
      break;
    case RelativeDateRange.LAST_3_MONTHS:
      setDateRangeFrom(dayjs().subtract(3, 'month'));
      break;
    case RelativeDateRange.LAST_6_MONTHS:
      setDateRangeFrom(dayjs().subtract(6, 'month'));
      break;
    case RelativeDateRange.LAST_YEAR:
      setDateRangeFrom(dayjs().subtract(1, 'year'));
      break;
    case RelativeDateRange.LAST_2_YEARS:
      setDateRangeFrom(dayjs().subtract(2, 'year'));
      break;
    case RelativeDateRange.LAST_3_YEARS:
      setDateRangeFrom(dayjs().subtract(3, 'year'));
      break;
  }
};

export { setDateRangeFrom, setDateRangeTo, setDateRange, setRelativeDateRange };
